import { render, staticRenderFns } from "./QualificationsStep.vue?vue&type=template&id=090533dc"
import script from "./QualificationsStep.vue?vue&type=script&lang=js"
export * from "./QualificationsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports